import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Use implicit flow (legacy default) instead of PKCE. PKCE is more secure
// but requires the auth link to be opened in the SAME browser session that
// requested it (a code_verifier sits in localStorage). For this app's UX —
// users routinely request a reset on a laptop and open the email on a phone
// — PKCE breaks with "Auth session missing" on the second device. Implicit
// flow puts the token in the URL hash and works across browsers/devices.
// The trade-off (token briefly visible in the URL fragment) is acceptable
// for a personal-tracking app on first-party domains, and our
// handleAuthLinkInUrl strips the hash immediately after consuming it.
export const supabase: SupabaseClient | null =
  url && key
    ? createClient(url, key, {
        auth: {
          flowType: "implicit",
          // CRITICAL: we own the URL handling via handleAuthLinkInUrl in
          // auth.tsx. supabase-js's auto-detect runs first on page load and
          // silently removes tokens from the URL even when its session
          // install fails — leaving us with an empty hash and no signal.
          // With detectSessionInUrl:false, our handler runs first, processes
          // both #access_token= and ?code= shapes, and logs/surfaces errors.
          detectSessionInUrl: false,
          persistSession: true,
          autoRefreshToken: true
        }
      })
    : null;

export const supabaseEnabled = supabase !== null;
